<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('administration.exchange_rate.date')
          }}<span class="text-danger">*</span>
        </label>
        <ts-date-picker-input v-model="model.value_date" />
        <div style="color:#cc4946;margin:4px 0 0">
          {{ errors.first('value_date') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">
          {{ $t('administration.exchange_rate.currency') }}
          <span class="text-danger">*</span></label
        >
        <select
          v-model="model.currency_id"
          class="form-control"
          :class="{ 'is-invalid': errors.has('currency_id') }"
        >
          <option value="" disabled selected style="display: none;"
            >--{{ $t('administration.exchange_rate.select') }}--</option
          >
          <option
            v-for="(currency, index) in currencies"
            :key="index"
            :value="currency.currency_id"
          >
            {{ currency.currency_code }}
          </option>
        </select>
        <div class="invalid-feedback" v-if="errors.has('currency_id')">
          {{ errors.first('currency_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('administration.exchange_rate.exchange_rate')
          }}<span class="text-danger">*</span>
        </label>
        <input
          v-model.number="model.exchange_rate"
          type="number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('exchange_rate') }"
        />
        <div class="invalid-feedback" v-if="errors.has('exchange_rate')">
          {{ errors.first('exchange_rate') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{
          $t('administration.exchange_rate.buy_rate')
        }}</label>
        <input
          v-model.number="model.exchange_buy"
          type="number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('exchange_buy') }"
        />
        <div class="invalid-feedback" v-if="errors.has('exchange_buy')">
          {{ errors.first('exchange_buy') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">{{
          $t('administration.exchange_rate.sell_rate')
        }}</label>
        <input
          v-model.number="model.exchange_sell"
          type="number"
          class="form-control"
          :class="{ 'is-invalid': errors.has('exchange_sell') }"
        />
        <div class="invalid-feedback" v-if="errors.has('exchange_sell')">
          {{ errors.first('exchange_sell') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'exchange-rate-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        value_date: moment().format('DD-MM-YYYY'),
        currency_id: '',
        exchange_rate: null,
        exchange_buy: null,
        exchange_sell: null
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  computed: {
    ...mapState('exchangeRate', ['currencies'])
  },
  created() {
    this.setEdit()
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'exchange-rate' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'exchangeRate/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'exchangeRate/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'exchange-rate' })
        this.editing = false
        this.$emit('success_create')
        this.clearForm()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return
      this.errors = new Errors()
      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.value_date = moment().format('DD-MM-YYYY')
      this.model.currency_id = ''
      this.model.exchange_rate = ''
      this.model.exchange_buy = ''
      this.model.exchange_sell = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
